import { sanitizeFilename } from '@vy/utils';
import { saveFileAsPdf } from './file-saver-as-pdf';

export async function saveInvoiceAsFile(
  encodedPdf: string,
  customerName: string,
  invoiceName: string,
) {

  const rawFileName = `${customerName} ${invoiceName}`;
  const sanitizedFileName = sanitizeFilename(rawFileName);

  return saveFileAsPdf(encodedPdf, sanitizedFileName);
}
